<template>
  <div class="item-warp">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.item-warp {
  margin: 10px 10px 10px 0;
  padding: 10px;
  border: 1px solid #eee;
  border-radius: 0 10px 10px 0;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
}
</style>